import { Modal } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';

import { BACKDROP_TRANSITION_DURATION_MS_DEFAULT } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PlainModal: Component = ({
  modalTitle,
  children,
  isOpen,
  backdropTransitionDurationMs = BACKDROP_TRANSITION_DURATION_MS_DEFAULT,
  onClose,
  className,
  contentClassName,
  titleClassName,
}) => {
  if (!children) {
    return (
      <Modal
        backdropTransitionDurationMs={backdropTransitionDurationMs}
        className={styles.containerRoot}
        contentClassName={styles.containerModalContent}
        isOpen={isOpen}
        title=""
        isBackdropStatic
        onClose={onClose} />
    );
  }

  return (
    <Modal
      backdropTransitionDurationMs={backdropTransitionDurationMs}
      className={cx(
        styles.containerRoot,
        className,
      )}
      contentClassName={cx(
        styles.containerModalContent,
        contentClassName,
      )}
      headerClassName={styles.containerHeader}
      isOpen={isOpen}
      title=""
      titleContainerClassName={styles.containerTitle}
      onClose={onClose}>
      <div className={cx(
        styles.textModelTitle,
        titleClassName,
      )}>
        {modalTitle}
      </div>
      {children}
    </Modal>
  );
};
